import ModalDialog from './modal-dialog';

const selectors = {
  notifyTrigger: '[data-notify-me-trigger]',
  notifyModal: '#modal-notify-me',
  notifyTitle: '[data-notify-title]',
  notifyForm: '[data-notify-form]',
  notifyVariant: '[data-notify-variant]',
  notifyFormError: 'notify-form__message--error',
};

export default function initProductNotifyMe(container) {
  // Initialise notify me modal (if trigger and modal exist)
  const notifyModalTrigger = container.querySelectorAll(selectors.notifyTrigger);
  if (!notifyModalTrigger || (notifyModalTrigger && notifyModalTrigger.length === 0)) return;

  const notifyModalElem = document.querySelector(selectors.notifyModal);
  if (!notifyModalElem) return;

  // eslint-disable-next-line no-unused-vars
  const notifyFormModal = new ModalDialog(notifyModalElem, {
    triggerEl: notifyModalTrigger,
    modalId: 'notify-me',
  });

  // Initialise notify me form submit (back in stock Klaviyo event)
  const notifyForm = notifyModalElem.querySelector(selectors.notifyForm);
  if (notifyForm) {
    notifyForm.addEventListener('submit', handleNotifyFormSubmit);

    const notifyTitle = notifyModalElem.querySelector(selectors.notifyTitle);
    const notifyVariant = notifyForm.querySelector(selectors.notifyVariant);

    notifyModalTrigger.forEach((button) => {
      button.addEventListener('click', (evt) => {
        evt.preventDefault();

        const productTitle = button.dataset.productTitle;
        const variant = button.dataset.variant;

        // If product title and variant found on button, update in the popup (not applicable to product page)
        if (productTitle && variant) {
          // Update popup title
          if (notifyTitle) {
            notifyTitle.textContent = productTitle;
          }

          // Update popup variant
          if (notifyVariant) {
            notifyVariant.value = variant;
          }
        }
      });
    });
  }
}

/**
 * Handles notify me form submit
 */
async function handleNotifyFormSubmit(event) {
  event.preventDefault();
  const form = event.target;
  const formElements = form.elements;

  if (
    !formElements.a.value ||
    !formElements.variant.value ||
    !formElements.platform.value ||
    !formElements.email.value
  ) {
    return;
  }

  const payload = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: formElements.email.value,
            },
          },
        },
        channels: ['EMAIL'],
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: `$shopify:::$default:::${formElements.variant.value}`,
          },
        },
      },
    },
  };

  try {
    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${formElements.a.value}`,
      {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-01-15',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response;

    let notifyFormMessage = form.querySelector('.notify-form__message');
    if (!notifyFormMessage) {
      notifyFormMessage = document.createElement('p');
      notifyFormMessage.classList.add('notify-form__message');
    }

    notifyFormMessage.innerHTML = data.ok
      ? window.theme.strings.productNotify.success
      : window.theme.strings.productNotify.error;

    form.appendChild(notifyFormMessage);

    if (data.ok) {
      notifyFormMessage.classList.remove(selectors.notifyFormError);
      formElements.email.value = '';
    } else {
      notifyFormMessage.classList.add(selectors.notifyFormError);
    }
  } catch (err) {
    window.console.error(err);
  }
}
